import { Component } from '@angular/core';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent {
  testimonials = [
    {
      name: 'Jan V.',
      location: 'Amsterdam',
      text: 'Via Kansino Nederland heb ik een geweldige casino site gevonden met een uitstekende welkomstbonus. De site is betrouwbaar en snel.',
      rating: 5
    },
    {
      name: 'Maria K.',
      location: 'Rotterdam',
      text: 'Ik waardeer de duidelijke beoordelingen en vergelijkingen. Het heeft me geholpen een weloverwogen keuze te maken.',
      rating: 5
    },
    {
      name: 'Pieter D.',
      location: 'Utrecht',
      text: 'De klantenservice van de site die ik via Kansino Nederland heb gevonden is uitstekend. Zeer tevreden!',
      rating: 4
    }
  ];
}

